import { Info } from '@/utils/icons';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';

interface InfoTooltipProps {
  text: string;
  wide?: boolean;
}

export function InfoTooltip({ text, wide }: InfoTooltipProps) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info className="dls-h-3.5 dls-w-3.5 dls-text-muted-foreground/60 hover:dls-text-muted-foreground dls-cursor-help dls-flex-shrink-0" />
        </TooltipTrigger>
        <TooltipContent className={cn('dls-text-left', wide ? 'dls-max-w-sm' : 'dls-max-w-xs')}>
          <p>{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
